// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"1e3d3ef84c21b83ddac5","655":"a27efec67a91f2cb33c7"}[chunkId] + ".js";
};